import type { FC, ReactNode } from 'react'

interface ManualRetouchingCardProps {
	icon: ReactNode
	title: string
	subtitle: string
	paragraph: string
	endSlot: ReactNode
}

export const ManualRetouchingCard: FC<ManualRetouchingCardProps> = ({
	icon,
	title,
	subtitle,
	paragraph,
	endSlot
}) => {
	return (
		<div className='flex h-[470px] flex-col items-center gap-7 rounded-2xl border border-neutral-300 p-6 text-center text-neutral-900 [&>svg]:text-neutral-900'>
			{icon}
			<div className='flex flex-col items-center gap-2'>
				<h3 className='font-medium text-lg'>{title}</h3>
				<div className='flex flex-col items-center gap-6'>
					<h4>{subtitle}</h4>
					<p>{paragraph}</p>
				</div>
			</div>
			{endSlot}
		</div>
	)
}
